export var EOrderBookType;
(function (EOrderBookType) {
    EOrderBookType["EQ"] = "OrderEquity";
    EOrderBookType["OEQ"] = "OpenOrderEquity";
    EOrderBookType["CEQ"] = "CloseOrderEquity";
    EOrderBookType["MF"] = "OrderMutualFunds";
    EOrderBookType["OMF"] = "OpenOrderMutualFunds";
    EOrderBookType["CMF"] = "CloseOrderMutualFunds";
    EOrderBookType["MFH"] = "OrderMutualFundsHoldings";
    EOrderBookType["OMFH"] = "OpenOrderMutualFundsHoldings";
    EOrderBookType["CMFH"] = "CloseOrderMutualFundsHoldings";
    EOrderBookType["NFO"] = "OrderNewFundOrder";
    EOrderBookType["FUT"] = "futures";
    EOrderBookType["OPT"] = "options";
    EOrderBookType["ETF"] = "ETF";
    EOrderBookType["NCD"] = "NCD";
    EOrderBookType["EQSIP"] = "EQSIP";
    EOrderBookType["MFSIP"] = "MFSIP";
    EOrderBookType["IPO"] = "IPO";
})(EOrderBookType || (EOrderBookType = {}));
